import { v4 as uuidv4 } from 'uuid'

export const Alert = class {
  constructor(type, message, autoClose, linkId = '', linkName = '') {
    this.id = uuidv4()
    this.type = type || 'info'
    this.message = message
    this.autoClose = autoClose || true
    this.state = 'open'
    this.linkId = linkId
    this.linkName = linkName
  }

  open() {
    this.state = 'open'
  }

  close() {
    this.state = 'close'
  }
}
